import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { TemplatesPage } from '@/features/templates/templates-page';

export const Route = createFileRoute('/_app/w/$workspaceId/templates/')({
    staticData: { crumbs: [{ label: 'shell.templates' }] },
    loader: ({ context }) => prefetch.templates(context.queryClient, context.workspaceScope),
    component: function TemplatesRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <TemplatesPage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
